var parent = require('../../actual/instance/index-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/instance/index-of.js
// module id = 1199
// module chunks = 142